export const URL_BACKEND = 'http://190.52.33.51:8084/api';
export const URL_BACKEND_PADRON = 'http://190.52.33.51:2703/api';
